import { fromJS } from "immutable";
import types from "./types";

export const initialState = fromJS({
  isModalOpen: false,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.TOGGLE_MODAL: {
      window.foo = state;
      return state.set("isModalOpen", action.open);
    }
    default: {
      return state;
    }
  }
};
